import { AgbSearchQuery } from "@shared/zod/schemas/requests/agb"
import { PublicAgbResponse } from "@shared/zod/schemas/responses/agb"

import { axiosPublic } from "./generic/AxiosInterceptor/AxiosInterceptor"

export const agbSearch = async (params: AgbSearchQuery): Promise<PublicAgbResponse[]> => {
  const resp = await axiosPublic({
    url: `/public/agb/search`,
    method: "get",
    params,
  })
  return resp.data
}
